import React, { useState, useContext } from 'react';
import { Input, Checkbox, Button, Form } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { storeInformation } from '../../../contexts/StoreInformationContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { customerProvider } from '../../../contexts/CustomerContext';
import { userProvider } from '../../../contexts/UserContext';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { domainProvider } from '../../../contexts/DomainContext';
import { toast } from 'react-toastify';

function LoginComponent() {
    const { t } = useTranslation();
    let selectLanguage = i18next.language;
    const { storeDetails } = useContext(storeInformation);
    const storeName = storeDetails?.data?.storeDetails?.store_name
        ? storeDetails?.data?.storeDetails?.store_name
        : window.location.href.split("/")[3];
    const { state } = useLocation();
    const { setIsCustomer, isCustomer } = useContext(customerProvider);
    const { refetchUser } = useContext(userProvider);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { customdomain } = useContext(domainProvider);

    const onFinish = async (values) => {
        values["store_name"] = storeName;
        setLoading(true);
        let res;

        try {
            if (customdomain === "aitech.com.sa") {
                res = await axios.post(
                    `${process.env.REACT_APP_APIURL}/vendor/store/customer/login`,
                    JSON.stringify(values),
                    { headers: { "Content-type": "application/json" } }
                );
            } else {
                res = await axios.post(
                    `${process.env.REACT_APP_APIURL}/vendor/store/customer/login`,
                    JSON.stringify(values),
                    {
                        headers: {
                            domain_name: customdomain,
                            "Content-type": "application/json",
                        },
                    }
                );
            }

            const response = await res.data;
            setLoading(false);

            if (response.status_code === 200) {
                toast.success("login successful");
                localStorage.setItem("customer", JSON.stringify(response));
                setIsCustomer(!isCustomer);
                if (state) {
                    navigate(state);
                    refetchUser();
                } else {
                    customdomain === "aitech.com.sa"
                        ? navigate(`/${storeName}`)
                        : navigate(`/`);
                }
            } else {
                toast.error(response.message);
            }
        } catch (err) {
            setLoading(false);
            toast.error("Login failed");
        }
    };

    return (
        <Form
            layout="vertical"
            onFinish={onFinish}
            className="border-dashed border-2 p-8 flex flex-col justify-center items-start w-full"
        >
            {/* Username */}
            <Form.Item
                label={
                    <span>
                        {t("cus_reg_title")} <span className="text-red-600">*</span>
                    </span>
                }
                name="username"
                rules={[{ required: true, message: t("Required") }]}
                className="w-full"
            >
                <Input placeholder={t("u_e")} className="h-[40px]" />
            </Form.Item>

            {/* Password */}
            <Form.Item
                label={
                    <div className="flex justify-between  w-full">
                        <span>
                            {t("l_p")} <span className="text-red-600">*</span>
                        </span>
                        <div>
                            <Link
                                className="text-sm"
                                to={
                                    customdomain === "aitech.com.sa"
                                        ? `/${storeName}/forgetPass`
                                        : `/forgetPass`
                                }
                            >
                                {t("lost_pass")}
                            </Link>
                        </div>
                    </div>
                }
                name="password"
                rules={[{ required: true, message: t("l_p_r") }]}
                className="w-full"
            >
                <Input.Password
                    placeholder={t("l_p")}
                    className="h-[40px]"
                    iconRender={(visible) =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                />
            </Form.Item>

            {/* Remember Me */}
            <Form.Item name="remember" valuePropName="checked" className="w-full mb-2">
                <Checkbox className="rounded-none">{t("l_p_remember")}</Checkbox>
            </Form.Item>

            {/* Submit & Resend */}
            <div className="flex flex-col justify-center items-center w-full">
                <button
                    type="primary"
                    htmlType="submit"
                     className="w-full btn btn-primary rounded-md text-white mt-4"
                    loading={loading}
                >
                    {t("HNav_login")}
                </button>
                <Link
                    className="text-gray-600 hover:text-primary text-lg"
                    to={
                        customdomain === "aitech.com.sa"
                            ? `/${storeName}/customer/resend-verification-email`
                            : `/customer/resend-verification-email`
                    }
                >
                    {t("Resend_verify_btn")}
                </Link>
            </div>
        </Form>
    );
}

export default LoginComponent;
